import React, { useRef, useEffect, useContext } from 'react';

// Components
import Hero from '../../../components/advanced/hero/Hero';
import ProfileBadge from '../../../components/advanced/profileBadge/ProfileBadge';
import Tooltip from '../../../components/advanced/tooltip/Tooltip';
import PersonalInfo from './components/personalInfo/PersonalInfo';

// Libraries
import { Container, MagicModal } from '@hybris-software/ui-kit';
import { useUser, PermissionRoute } from '@hybris-software/use-auth';
import useQuery from '@hybris-software/use-query';
import { useNavigate } from 'react-router-dom';

// Svgs
import Copy from '../../../assets/svgs/Copy';

// Hooks
import useText from '../../../hooks/useText';

// Data
import endpoints from '../../../data/endpoints';
import config from '../../../data/config';

// Contexts
import { RoutesContext } from '../../../contexts/RoutesContext';

// Utils
import dispatcher from '../../../utils/dispatcher';

// Styles
import Style from './ProfileView.module.css';

const ProfileView = () => {
	// Hooks
	const copy = useText('copyTooltip');
	const texts = useText('profileView');
	const { userInfo } = useUser();
	const navigate = useNavigate();
	// Refs
	const modalRef = useRef();
	// Contexts
	const { paths } = useContext(RoutesContext);

	const getUserInfoApi = useQuery({
		url: endpoints.user.RESIDENTIALINFORMATION,
		method: 'GET',
		executeImmediately: true,
	});

	const countriesApi = useQuery({
		url: endpoints.auth.COUNTRIES,
		method: 'GET',
		executeImmediately: true,
	});

	useEffect(() => {
		document.title = `${config.PLATFORM_NAME} | ${texts?.pageTitle}`;
	}, [texts?.pageTitle]);

	return (
		<PermissionRoute
			// loader={<Loader />}
			minimumLoadingTime={500}
			forLoggedUser={true}
			firstApiLoading={getUserInfoApi.isLoading || countriesApi.isLoading}
			unAuthorizedAction={() => {
				navigate(paths.auth.login);
			}}
			permissionController={(response) => {
				dispatcher(response.data, navigate, paths);
				return true;
			}}
		>
			<MagicModal ref={modalRef} />

			<Hero>
				<Container>
					<div className={Style.header}>
						<h3 className={Style.title}>{texts?.title}</h3>
						<div className={Style.referral}>
							<div className={Style.referralText}>
								{texts?.cardReferral}{' '}
								{`${config.BASE_URL}auth/register?refcode=${userInfo?.referralCode}` ||
									'--'}
							</div>

							<Tooltip
								valueToCopy={
									`${config.BASE_URL}auth/register?refcode=${userInfo?.referralCode}` ||
									'--'
								}
								copyIcon={<Copy />}
								textCopy={copy?.copied}
							/>
						</div>
					</div>
					<ProfileBadge modalRef={modalRef} />
				</Container>
			</Hero>

			<Container>
				<PersonalInfo
					response={getUserInfoApi?.response?.data}
					countries={countriesApi?.response?.data}
					modalRef={modalRef}
				/>
			</Container>
		</PermissionRoute>
	);
};

export default ProfileView;
